<script lang="ts">
  export interface PageMainProps {
    class?: HTMLAttributes['class']
    /** The alignment of the container.
     * @default 'self-center'
     */
    align?: 'self-center' | 'self-start' | 'self-end'
    /** The width of the container.
     * @default 'max-w-6xl'
     */
    width?: 'max-w-6xl' | 'max-w-full' | 'max-w-4xl'
  }
</script>

<script setup lang="ts">
  import { cn } from '@gat-ship/vue-components'
  import { type HTMLAttributes } from 'vue'

  const props = withDefaults(defineProps<PageMainProps>(), {
    align: 'self-center',
    width: 'max-w-6xl'
  })
</script>

<template>
  <div
    :class="
      cn(
        '@container flex w-full flex-col px-4 lg:px-8',
        props.align,
        props.width,
        props.class
      )
    "
  >
    <slot />
  </div>
</template>
